<template>
  <div>
    <v-form v-model="ownerInfoForm" ref="form">
      <v-row class="w--100">
        <v-col cols="12" sm="6">
          <v-text-field
            required
            :rules="[(v) => !!v || 'وارد کردن مقدار الزامی میباشد']"
            v-model="form.managerPerson.firstName"
            type="text"
            label="نام *"
            outlined
            dense
            :disabled="merchantIsApproved"
          />
        </v-col>
        <v-col cols="12" sm="6">
          <v-text-field
            required
            :rules="[(v) => !!v || 'وارد کردن مقدار الزامی میباشد']"
            v-model="form.managerPerson.lastName"
            type="text"
            label="نام خانوادگی *"
            outlined
            dense
            :disabled="merchantIsApproved"
          />
        </v-col>
        <template>
          <v-col cols="12" md="4" sm="6">
            <v-text-field
              v-model="form.managerPerson.nationalCode"
              outlined
              type="number"
              dense
              :rules="[
                (v) => {
                  if (v && !/^(\d{10,10})+$/.test(v)) {
                    return 'کد ملی حتما باید عدد و 10 رقم باشد';
                  } else return true;
                },
              ]"
              maxlength="10"
              counter
              label=" کد ملی"
              :disabled="
                merchantIsApproved && !merchantMonitorFields.NationalId
                  ? true
                  : false
              "
            />
          </v-col>
          <v-col cols="12" md="4" sm="6">
            <v-text-field
              label="تلفن همراه *"
              v-model="form.managerPerson.mobile"
              type="number"
              outlined
              dense
              required
              :rules="[
                (v) => {
                  if (!v) {
                    return 'وارد کردن مقدار الزامی میباشد';
                  } else if (v && !/^(\d{11,11})+$/.test(v)) {
                    return 'تلفن حتما باید عدد و 11 رقم باشد';
                  } else return true;
                },
              ]"
              counter="11"
              :disabled="merchantIsApproved"
            />
          </v-col>
          <!-- <v-col cols="12" md="4" sm="6">
            <div>
              <date-picker
                :clearable="true"
                :max="subYearsOfDate(19)"
                :initial-value="subYearsOfDate(20)"
                simple
                v-model="form.managerPerson.birthdate"
                format="YYYY-MM-DD"
                display-format="jYYYY-jMM-jDD"
                ref="mangerBirthDate"
                label="تاریخ تولد"
                :disabled="merchantIsApproved"
              ></date-picker>
            </div>
          </v-col> -->
          <v-col cols="12" md="4" sm="6">
            <v-radio-group
              v-model="form.managerPerson.gender"
              class="mt-0"
              row
              :disabled="merchantIsApproved"
            >
              <v-radio class="" label="زن" value="Female"></v-radio>
              <v-radio class="" label="مرد" value="Male"></v-radio>
            </v-radio-group>
          </v-col>
          <v-col cols="12">
            <v-checkbox
              hide-details
              v-model="form.creatorIsManager"
              :label="
                form.creatorIsManager
                  ? 'خودم صاحب  کسب و کار هستم.': $store.getters.currentUserIsVisitor ? '' :
                   'اگر صاحب کسب و کار هستید این تیک را بزنید در غیر اینصورت نیازی نیست'
              "
            >
            </v-checkbox>
            <span v-if="!form.creatorIsManager" class="text-center"  style ="color: #0D47A1;font-weight: 600;">وقتی این گزینه تیک ندارد یعنی ثبت نام کسب و کار توسط شخص دیگری به غیر از صاحب کسب و کار انجام می‌شود.</span>
            <span v-if="!form.creatorIsManager">این شخص ممکن است از همکاران بازاریاب تکصان یا همکار کسب و کار باشد.</span>
          
          </v-col>
          <v-col cols="12">
            <v-sheet
              outlined
              class="pa-1 pa-md-7"
              v-if="!form.creatorIsManager"
            >
              <v-row>
                <v-col cols="12" sm="6">
                  <v-text-field
                    required
                    :rules="[(v) => !!v || 'وارد کردن مقدار الزامی میباشد']"
                    v-model="form.creatorPerson.firstName"
                    type="text"
                    label="نام ثبت نام کننده *"
                    outlined
                    dense
                    :disabled="merchantIsApproved"
                  />
                </v-col>
                <v-col cols="12" sm="6">
                  <v-text-field
                    required
                    :rules="[(v) => !!v || 'وارد کردن مقدار الزامی میباشد']"
                    v-model="form.creatorPerson.lastName"
                    type="text"
                    label="نام خانوادگی ثبت نام کننده *"
                    outlined
                    dense
                    :disabled="merchantIsApproved"
                  />
                </v-col>
                <v-col cols="12" md="4" sm="6">
                  <v-text-field
                    v-model="form.creatorPerson.nationalCode"
                    outlined
                    type="number"
                    dense
                    :rules="[
                      (v) => {
                        if (v && !/^(\d{10,10})+$/.test(v)) {
                          return 'کد ملی حتما باید عدد و 10 رقم باشد';
                        } else return true;
                      },
                    ]"
                    maxlength="10"
                    counter
                    label="کد ملی "
                    :disabled="
                      merchantIsApproved && !merchantMonitorFields.NationalId
                        ? true
                        : false
                    "
                  />
                </v-col>
                <!-- <v-col cols="12" md="4" sm="6">
                  <div>
                    <date-picker
                      :clearable="true"
                      :max="subYearsOfDate(19)"
                      :initial-value="subYearsOfDate(20)"
                      simple
                      v-model="form.creatorPerson.birthdate"
                      format="YYYY-MM-DD"
                      display-format="jYYYY-jMM-jDD"
                      ref="mangerBirthDate"
                      label="تاریخ تولد"
                      :disabled="merchantIsApproved"
                    ></date-picker>
                  </div>
                </v-col> -->
                <v-col cols="12" md="4" sm="6">
                  <v-radio-group
                    v-model="form.creatorPerson.gender"
                    class="mt-0"
                    row
                    :disabled="merchantIsApproved"
                  >
                    <v-radio class="" label="زن" value="Female"></v-radio>
                    <v-radio class="" label="مرد" value="Male"></v-radio>
                  </v-radio-group>
                </v-col>
              </v-row>
            </v-sheet>
          </v-col>
        </template>
        <v-col cols="12" v-if="!isEdit && !addNewMerchantCompany">
          <v-radio-group
            v-model="submitAsBuyerFlag"
            class="mt-0"
            row
            :disabled="merchantIsApproved"
          >
            <v-radio
              class=""
              label="ثبت نام به عنوان کسب و کار "
              :value="false"
            ></v-radio>
            <v-radio
              class=""
              label="ثبت نام به عنوان خریدار"
              :value="true"
            ></v-radio>
          </v-radio-group>
        </v-col>
        <v-col cols="12" class="mt-0" v-if="!submitAsBuyerFlag">
          <v-sheet outlined class="pa-1 pa-md-3 mb-3">
            <div class="d-flex flex-row">
              <h4 class="blue--text">نوع فعالیت خود را انتخاب کنید.</h4>
              <HelperComponent helperId="how-i-work" class="mx-2" />
            </div>

            <v-radio-group
              v-model="form.isManufacturer"
              class="text-right"
              row
              :disabled="
                merchantIsApproved && !merchantMonitorFields.isManufacturer
                  ? true
                  : false
              "
            >
              <v-radio
                class=""
                label="صنعتگر هستم ( سازنده صنعتی/طراح و مشاور)"
                :value="true"
              ></v-radio>
              <v-radio
                class=""
                label="فروشنده و تاجر هستم"
                :value="false"
              ></v-radio>
            </v-radio-group>
          </v-sheet>
        </v-col>
        <v-col cols="12" class="mt-0" v-if="!isEdit && !addNewMerchantCompany">
          <v-checkbox
            v-model="setFullInfoSubmition"
            label="تمایل به ثبت اطلاعات  تکمیلی را دارم(توصیه می‌شود) "
            class="mt-n3"
          ></v-checkbox>
        </v-col>
        <v-col
          cols="12"
          class="mt-0 d-flex flex-row"
          v-if="!isEdit && !addNewMerchantCompany"
        >
          <v-checkbox
            v-model="taksaanTerms"
            label=" قوانین و مقررات سایت تکصان را مطالعه و تایید می نمایم."
            class="mt-n3"
          >
          </v-checkbox>
          <v-btn
            class="mt-n4"
            color="primary"
            text
            @click="openPublicTaksaanInfo()"
          >
            مشاهده
          </v-btn>
        </v-col>
      </v-row>
    </v-form>
    <v-dialog v-if="taksaanModal" v-model="taksaanModal" width="900px">
      <v-card>
        <v-card-title>{{ taksaanModalTitle }}</v-card-title>
        <v-divider />
        <v-card-text> <div v-html="taksaanModalBody"></div> </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="error" @click="taksaanModal = false"> بستن </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { RepoFactory } from '@/baseRepository/Factory';
const authRepository = () => RepoFactory.get('auth');
const pagesRepository = () => RepoFactory.get('pages');
import Helper from '@/core/helpers';
import reusableMethodsMixin from '@/core/mixins/reusableMethodsMixin';
import asyncLoadMixin from '@/core/mixins/asyncLoadMixin';
import VuePersianDatetimePicker from 'vue-persian-datetime-picker';
export default {
  mixins: [reusableMethodsMixin, asyncLoadMixin],
  props: {
    validateOwnerInfo: {
      type: Boolean,
      default: false,
    },
    validationErr: {
      type: Object,
      default: null,
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
    businessRegistrationData: {
      type: Object,
      default: null,
    },
    merchantIsApproved: {
      type: Boolean,
      default: false,
    },
    merchantMonitorFields: {
      type: Object,
      default: null,
    },
    addNewMerchantCompany: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    datePicker: VuePersianDatetimePicker,
  },
  data() {
    return {
      //Like this object Exited in Genel Form, be careful
      form: {
        creatorIsManager: true,
        isManufacturer: true,
        managerPerson: {
          firstName: null,
          lastName: null,
          gender: 'Male',
          birthdate: null,
          nationalCode: null,
          memberType: 'Manager',
          mobile: '',
        },
        creatorPerson: {
          firstName: null,
          lastName: null,
          gender: 'Male',
          birthdate: null,
          nationalCode: null,
          memberType: 'Other',
        },
      },
      ownerInfoForm: true,
      submitAsBuyerFlag: false,
      setFullInfoSubmition: false,
      taksaanTerms: false,
      taksaanModal: false,
      taksaanModalTitle: '',
      taksaanModalBody: '',
      userInfo: {
        firstName: null,
        lastName: null,
        gender: 'Male',
        birthdate: null,
        nationalCode: null,
        phone:null,
      },
    };
  },
  computed: {
    merchantBaseUrl() {
      return this.$store.getters.merchantBaseUrl;
    },
    contentBaseUrl() {
      return this.$store.getters.contentBaseUrl;
    },
  },
  created() {
    if (this.isEdit) {
      this.taksaanTerms = true;
      this.setFullInfoSubmition = true;
      if (this.businessRegistrationData) {
        this.fillValue(this.businessRegistrationData);
      }
    } else if (this.addNewMerchantCompany) {
      this.taksaanTerms = true;
      this.setFullInfoSubmition = true;
      this.form.managerPerson.firstName =
        this.businessRegistrationData.managerPerson?.firstName;
      this.form.managerPerson.lastName =
        this.businessRegistrationData.managerPerson?.lastName;
      this.form.managerPerson.birthdate =
        this.businessRegistrationData.managerPerson?.birthdate;
      this.form.managerPerson.gender =
        this.businessRegistrationData.managerPerson?.gender;
      this.form.managerPerson.nationalCode =
        this.businessRegistrationData.managerPerson?.nationalCode;
      this.form.managerPerson.mobile =
        '0' + this.businessRegistrationData.managerPerson?.phone;
      this.getData();
    } else {
      this.getData();
    }
  },
  watch: {
    'form.creatorPerson.birthdate': function () {
      if (
        this.form.creatorPerson.birthdate == null ||
        this.form.creatorPerson.birthdate.includes('0001-01-01')
      ) {
        var date = new Date();
        date.setFullYear(date.getFullYear() - 20);
        this.form.creatorPerson.birthdate = date
          .toJSON()
          .slice(0, 10)
          .replace(/ ' '/g, '-');
      }
    },
    'form.managerPerson.birthdate': function () {
      if (
        this.form.managerPerson.birthdate == null ||
        this.form.managerPerson.birthdate.includes('0001-01-01')
      ) {
        var date = new Date();
        date.setFullYear(date.getFullYear() - 20);
        this.form.managerPerson.birthdate = date
          .toJSON()
          .slice(0, 10)
          .replace(/ ' '/g, '-');
      }
    },
    validateOwnerInfo(aft, bef) {
      if (aft) {
        if (this.$refs.form.validate()) {
          if (!this.form.creatorIsManager) { //For register creator person info           
            if (this.form.creatorPerson.nationalCode == this.form.managerPerson.nationalCode) {
              //Rase error 
            this.$emit('validationFailed');
            alert("کد ملی صاحب کسب و کار و  ایجاد کننده نباید یکسان باشد حتی مقادیر خالی")
           }
          
          }
          if (!this.isEdit) {
            if (this.form.creatorIsManager) {
              this.form.creatorPerson.firstName =
                this.form.managerPerson.firstName;
              this.form.creatorPerson.lastName =
                this.form.managerPerson.lastName;
              this.form.creatorPerson.gender = this.form.managerPerson.gender;
              this.form.creatorPerson.birthdate =
                this.form.managerPerson.birthdate;
              this.form.creatorPerson.nationalCode =
                this.form.managerPerson.nationalCode;
            }
          }
          this.$emit('nextStep', this.form, 'ownerInfo');
        } else {
          this.$emit('validationFailed');
        }
      }
    },
    submitAsBuyerFlag(after) {
      this.$emit('submitAsBuyerFlagChange', after);
    },
    setFullInfoSubmition(after) {
      this.$emit('setFullInfoSubmitionData', after);
    },
    taksaanTerms(after) {
      this.$emit('changeTaksaanTerms', after);
    },
    'form.creatorIsManager': function (after) {
      if (after && !this.isEdit) {
        this.form.creatorPerson.firstName = this.form.managerPerson.firstName;
        this.form.creatorPerson.lastName = this.form.managerPerson.lastName;
        this.form.creatorPerson.gender = this.form.managerPerson.gender;
        this.form.creatorPerson.birthdate = this.form.managerPerson.birthdate;
        this.form.creatorPerson.memberType = 'Other';
           this.form.creatorPerson.nationalCode =
           this.userInfo.nationalCode;
         //this.form.creatorPerson = {
          // firstName: null,
          // lastName: null,
          // gender: null,
          // birthdate: null,
          // nationalCode: null,
         // memberType: 'Other',
       //};
       
    
      } else if (!after && !this.isEdit) {
         
        this.form.creatorPerson = {
          firstName: this.userInfo.firstName,
          lastName: this.userInfo.lastName,
          gender: this.userInfo.gender,
          birthdate: this.userInfo.birthdate,
          nationalCode: this.userInfo.nationalCode,
          memberType: 'Other',
        };
      }
    },
  },
  methods: {
    fillValue(data) {
      this.form.managerPerson.id = data.managerPerson.id;
      this.form.creatorPerson.id = data.creatorPerson.id;
      this.form.managerPerson.firstName = data.managerPerson.firstName;
      this.form.managerPerson.lastName = data.managerPerson.lastName;
      this.form.managerPerson.gender = data.managerPerson.gender
        ? data.managerPerson.gender
        : null;
      this.form.managerPerson.birthdate = data.managerPerson.birthdate;
      this.form.managerPerson.nationalCode = data.managerPerson.nationalCode
        ? data.managerPerson.nationalCode
        : null;
      this.form.managerPerson.mobile = data.managerPerson.mobile;
      this.form.creatorPerson.firstName = data.creatorPerson.firstName;
      this.form.creatorPerson.lastName = data.creatorPerson.lastName;
      this.form.creatorPerson.gender = data.creatorPerson.gender
        ? data.creatorPerson.gender
        : null;
      this.form.creatorPerson.birthdate = data.creatorPerson.birthdate;
      this.form.creatorPerson.nationalCode = data.creatorPerson.nationalCode
        ? data.creatorPerson.nationalCode
        : null;
      this.form.creatorIsManager = data.creatorIsManager;
      this.form.isManufacturer = data.isManufacturer;
      this.submitAsBuyerFlag = !data.isSupplier;
    },
    openPublicTaksaanInfo() {
      const loader = this.$loading.show();
      let params = {
        uniquePageName:
          this.$store.getters
            .uniquePageApprovingTaksaanRuleOnMerchantsRegistration,
      };
      pagesRepository()
        .getUniquePage(this.contentBaseUrl, {}, params)
        .then(({ data }) => {
          this.taksaanModalTitle = data.title;
          this.taksaanModalBody = data.body;
          this.taksaanModal = true;
        })
        .catch((error) => {
          Helper.handleErrors(error, this);
        })
        .finally(() => {
          loader.hide();
        });
    },
    async getData() {
      const loader = this.$loading.show();
      await authRepository()
        .getUserDetail(this.$store.getters.authBaseUrl)
        .then((res) => {
          console.log('authData');
          console.log(res);
          this.form.managerPerson.mobile = '0' + res.data.phone;
          this.form.managerPerson.nationalCode =
            (res.data.nationalCode.length == 10 && !this.$store.getters.currentUserIsVisitor) ? +res.data.nationalCode : null;
          if (this.$store.getters.currentUserIsVisitor) {
            this.form.creatorIsManager=false;
           }
          this.userInfo = {
            firstName: res.data.firstName,
            lastName: res.data.lastName,
            gender: res.data.gender,
            birthdate:  res.data.birthdate,
            phone: '0' + res.data.phone,
            nationalCode:  res.data.nationalCode,
        
          };
        })
        .catch((error) => {
          Helper.handleErrors(error, this);
        })
        .finally(() => {
          loader.hide();
        });
    },
  },
};
</script>

<style></style>
